import axios from '../axios'

/*
 * 项目
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/mProject/save',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
// 删除
export const deleteProject = (data) => {
  return axios({
    url: '/mProject/delete',
    method: 'post',
    data
  })
};
// 分页查询
export const list = (data) => {
  return axios({
    url: '/mProject/list',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
export const findProjectBeanById = (data) => {
  return axios({
    url: '/mProject/findProjectBeanById',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/http/moudules/project.js